<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'FUEL_LIST',
    }"
  >
    <el-tabs
      v-model="activeName"
      type="card"
      v-if="!$route.name.includes('ADD')"
    >
      <el-tab-pane
        v-for="tab in types"
        :key="tab.name"
        :lazy="true"
        :label="$t(tab.label)"
        :name="tab.name"
      >
        <component
          :is="tab.name"
          :fuel="fuel"
          v-if="activeName == tab.name"
          :loading="loading"
        ></component>
      </el-tab-pane>
    </el-tabs>
    <Basic v-else :fuel="fuel" :loading="loading" />
  </Content>
</template>
<script>
import Basic from '@/components/fuel/Basic'
import Quota from '@/components/fuel/Quota'


export default {
  props: {
    fuel: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Basic,
    Quota,
  },
  data() {
    return {
      activeName: 'Basic',
      types: [
        {
          name: 'Basic',
          label: 'BASIC_INFO',
        },
        {
          name: 'Quota',
          label: 'subsidized_capacity',
        },
      ],

      submitLoading: false,
      fuelTypes: [],
      fuelTypeLoading: true,
      list: [],
      ruleForm: {
        description: '',
        serial_number: '',
        company_vehicle: {
          id: '',
        },
        type: {
          id: '',
        },
        title: '',
        password: '',
        is_active: true,
        free_capacity: '',
        quota_capacity_during_add: '',
      },
    }
  },
  watch: {
    fuel(val) {
      this.ruleForm = val
    },
  },
  methods: {},
  created() {
    
  },
}
</script>
